import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="text-ivory py-12 md:py-16" style={{ backgroundColor: '#000000' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
          {/* Brand Column */}
          <div className="md:col-span-5">
            <Link to="/" className="block hover:opacity-80 transition-opacity duration-300">
              <img 
                src="/logo-gold-trimmed.jpeg" 
                alt="Novum Royale" 
                className="h-20 md:h-24 w-auto"
              />
            </Link>
            <p className="mt-4 text-ivory/60 font-light leading-relaxed max-w-sm text-sm">
              Confidential by design. An integrated commercial and creative growth partner for ambitious organisations.
            </p>
            <div className="mt-4 flex items-center space-x-1">
              <span className="w-8 h-px bg-gold"></span>
              <span className="text-xs uppercase tracking-[0.2em] text-gold font-medium">
                UK-based, global delivery
              </span>
            </div>
          </div>

          {/* Navigation Column */}
          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-ivory/40 font-semibold mb-6">
              Navigate
            </h4>
            <nav className="space-y-4">
              <Link
                to="/"
                data-testid="footer-home"
                className="block text-sm text-ivory/80 hover:text-gold transition-colors duration-300"
              >
                Home
              </Link>
              <Link
                to="/capabilities"
                data-testid="footer-capabilities"
                className="block text-sm text-ivory/80 hover:text-gold transition-colors duration-300"
              >
                Capabilities
              </Link>
              <Link
                to="/about"
                data-testid="footer-about"
                className="block text-sm text-ivory/80 hover:text-gold transition-colors duration-300"
              >
                About
              </Link>
              <Link
                to="/contact"
                data-testid="footer-contact"
                className="block text-sm text-ivory/80 hover:text-gold transition-colors duration-300"
              >
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Column */}
          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-ivory/40 font-semibold mb-6">
              Connect
            </h4>
            <div className="space-y-4">
              <a
                href="mailto:novumroyale@hotmail.com"
                data-testid="footer-email"
                className="block text-sm text-ivory/80 hover:text-gold transition-colors duration-300"
              >
                novumroyale@hotmail.com
              </a>
            </div>
            <div className="mt-8 pt-8 border-t border-ivory/10">
              <p className="text-xs text-ivory/40 leading-relaxed">
                Capabilities deck available on request.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-ivory/10 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-xs text-ivory/40">
            © {currentYear} Novum Royale. All rights reserved.
          </p>
          <img 
            src="/logo-crest.jpeg" 
            alt="" 
            className="h-8 w-8 opacity-60 rounded-full"
            aria-hidden="true"
          />
          <p className="text-xs text-ivory/40">
            novumroyale.com
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
